const ACTIONS = {
    CREATE_REQUEST: "CREATE_PRODUCT_REQUEST",
    CREATE_SUCCESS: "CREATE_PRODUCT_SUCCESS",
    CREATE_FAIL: "CREATE_PRODUCT_FAIL",

    FETCH_REQUEST: "FETCH_PRODUCT_REQUEST",
    FETCH_SUCCESS: "FETCH_PRODUCT_SUCCESS",
    FETCH_FAIL: "FETCH_PRODUCT_FAIL",

    FETCH_ALL_REQUEST: "FETCH_ALL_PRODUCTS_REQUEST",
    FETCH_ALL_SUCCESS: "FETCH_ALL_PRODUCTS_SUCCESS",
    FETCH_ALL_FAIL: "FETCH_ALL_PRODUCTS_FAIL",

    UPDATE_REQUEST: "UPDATE_PRODUCT_REQUEST",
    UPDATE_SUCCESS: "UPDATE_PRODUCT_SUCCESS",
    UPDATE_FAIL: "UPDATE_PRODUCT_FAIL",

    DELETE_REQUEST: "DELETE_PRODUCT_REQUEST",
    DELETE_SUCCESS: "DELETE_PRODUCT_SUCCESS",
    DELETE_FAIL: "DELETE_PRODUCT_FAIL",

};

export default ACTIONS;
